import React from "react";
import { Select } from "../../../../../../shared/infrastructure/ui";
import { SelectComponentProps } from "./types";
import { useInfiniteGetCarriers } from "../../../services";
import { withSelectOptions } from "./with-select-options";
import { CarrierT, UseGetCarriersFilters } from "../../../../domain/entities";

const RenderOption = ({ name, carrier_id }: CarrierT): React.ReactElement => {
  return (
    <section className="grid w-[250px] grid-flow-col items-center justify-between gap-[10px] px-[5px] text-[12px]">
      <span className="overflow-hidden text-ellipsis whitespace-nowrap">
        {name ?? "- -"}
      </span>
      <span className="rounded-[5px] bg-[#F4F4F4] py-[5px] px-[10px] text-[10px]">
        {carrier_id ?? "- -"}
      </span>
    </section>
  );
};

const CarrierSelectComponent = ({
  placeholder,
  name = "",
  selectedValue,
  onChangeValue,
  error = "",
  variant = "standard",
  disabled = false,
  handleSetKeyword,
  isLoading,
  getNextPage,
  noMore,
  data,
  noError,
  labelProp = "name",
  keyword,
  multiselect,
  required,
}: SelectComponentProps<CarrierT>): React.ReactElement => {
  return (
    <Select<CarrierT>
      searchValue={keyword}
      multiselect={multiselect}
      disabled={disabled}
      loading={isLoading}
      placeholder={placeholder}
      options={data}
      name={name}
      asyncFilter={handleSetKeyword}
      labelProp={labelProp}
      value={selectedValue}
      onChange={onChangeValue}
      noMore={noMore}
      getMore={getNextPage}
      renderOptionComponent={RenderOption}
      error={error}
      variant={variant}
      noError={noError}
      required={required}
    />
  );
};

export const CarrierSelect = withSelectOptions<CarrierT, UseGetCarriersFilters>(
  CarrierSelectComponent,
  useInfiniteGetCarriers,
  "s"
);
